/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-study': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.579 6.572a.466.466 0 01.481.467v.475a1.878 1.878 0 00-1.874 1.872v1.88a1.876 1.876 0 001.863 1.87v.487a.469.469 0 01-.471.47 10.991 10.991 0 00-6.121 1.909V8.091a11.8 11.8 0 016.122-1.519zm-13.161 0A11.891 11.891 0 017.54 8.091v7.9a10.973 10.973 0 00-6.122-1.909.469.469 0 01-.48-.475v-.469a1.878 1.878 0 001.874-1.871V9.386A1.878 1.878 0 00.936 7.514v-.473a.469.469 0 01.48-.467zm13.643 1.877a.939.939 0 01.938.937v1.88a.939.939 0 01-1.874 0v-1.88a.937.937 0 01.937-.937zm-14.125.05a.936.936 0 01.937.887v1.88a.939.939 0 01-1.873 0v-1.88a.939.939 0 01.937-.888zm8-2.866a4.219 4.219 0 011.88.462A11.762 11.762 0 008 7.262a11.774 11.774 0 00-2.819-1.168 4.219 4.219 0 011.88-.462zM6.01.821a2.815 2.815 0 014.8 2 2.812 2.812 0 11-4.8-2z" _fill="#212121"/>'
  }
})
